import React from 'react';
import PropTypes from 'prop-types';
import autoBind from 'react-autobind';
import classnames from 'classnames';
import { checkSearchExternalErrors } from '../../../utils/utils';
import _isString from 'lodash/isString';
import style from './style';
import AlgoliaPlaces from '../AlgoliaPlaces';
import config from '../../../constants/config';

class LocationInput extends React.Component {
  constructor(props, context) {
    super(props, context);
    autoBind(this);
    this.setApiKeys();
  }

  setApiKeys() {
    const { algoliaAppId, algoliaApiKey } = config || {};

    this.algoliaAppId = algoliaAppId;
    this.algoliaApiKey = algoliaApiKey;
  }

  handleSuggestSelected(suggestion) {
    const { latlng } = suggestion || {};

    if (latlng) {
      this.coordinates = {
        latitude: latlng.lat,
        longitude: latlng.lng
      };
    }

    this.formatAddress(suggestion);

    if (this.props.openDatePickerOnSelect) {
      let errors = checkSearchExternalErrors(this.props.externalErrors);

      let i = document.getElementById('mobileSearch')
        ? document.querySelector('form.mobileOnly')
          ? 2
          : 0
        : 0;
      let selector = '';
      if (
        errors.hasOwnProperty('sd') &&
        (errors.sd === false || (_isString(errors.sd) && errors.sd !== ''))
      ) {
        selector = 'div.date-picker';
      } else if (errors.st === null) {
        selector = 'div.time-picker';
      } else if (
        errors.hasOwnProperty('ed') &&
        (errors.ed === false || (_isString(errors.ed) && errors.ed !== ''))
      ) {
        selector = 'div.date-picker';
        i += 1;
      } else if (errors.et === null) {
        selector = 'div.time-picker';
        i += 1;
      }
      if (selector !== '') {
        document.querySelectorAll(`${selector}`)[i].querySelector('input').click();
      }
    }
  }

  formatAddress(suggestion = {}) {
    const { latlng, city, countryCode, value, postcode, name, country } = suggestion;
    const ret = { formattedAddress: value };

    if (latlng) {
      ret.coordinates = {
        latitude: latlng.lat,
        longitude: latlng.lng
      };
    } else ret.GEO_MISSING = true;

    if (city) ret.city = city;
    if (name) ret.streetName = name;
    if (postcode) ret.postalCode = postcode;
    if (country) ret.country = country;
    if (countryCode) ret.countryISO = countryCode.toUpperCase();

    if (this.props.isStreet) this.setValue(name);
    if (ret.GEO_MISSING) {
      ret.siteId = suggestion.id;
      ret.address = suggestion.address;
    }

    this.props.onLocationSelected(ret);
  }

  onChange(value) {
    const { onChange, onEmpty, isValue, isStreet } = this.props;
    if (value) (isStreet || isValue) && onChange({ value });
    else onEmpty && onEmpty({});
  }

  getInitialValue() {
    const { initialValue, isStreet, isValue } = this.props;
    if (typeof initialValue === 'string') return initialValue;
    let { streetNumber, streetName, value, formattedAddress } = initialValue || {};
    streetNumber = streetNumber ? streetNumber + ' ' : '';
    const street = streetNumber + (streetName || '') || value || '';
    return isStreet
      ? street
      : isValue
      ? value || formattedAddress || streetName
      : formattedAddress || '';
  }

  setValueSetter(setter) {
    this.valueSetter = setter;
  }

  setValue(value) {
    if (this.valueSetter) this.valueSetter(value);
  }

  getAlgolia() {
    const { disabled } = this.props;
    const value = this.getInitialValue();
    if (disabled) return <span className="sub-class-disabled">{value}</span>;

    return (
      <AlgoliaPlaces
        placeholder={this.props.placeholder}
        showCurrentLocationButton={this.props.showCurrentLocationButton}
        initialValue={value}
        language={this.props.language}
        fixtures={this.props.fixtures}
        fixturesTitle={this.props.fixturesTitle}
        historyTitle={this.props.historyTitle}
        maxFixtures={this.props.maxFixtures}
        searchHistoryEnabled={this.props.searchHistoryEnabled}
        placesOptions={{
          appId: this.algoliaAppId,
          apiKey: this.algoliaApiKey,
          type: this.props.searchType,
          countries: this.props.countries
        }}
        onSelect={this.handleSuggestSelected}
        onInputChange={this.onChange}
        getValueSetter={this.setValueSetter}
      />
    );
  }

  render() {
    return (
      <div
        className={classnames('location-input', {
          'has-input-pin': this.props.getLocation
        })}
      >
        {this.getAlgolia()}
        <style jsx global>
          {style}
        </style>
      </div>
    );
  }
}

LocationInput.propTypes = {
  disabled: PropTypes.bool,
  showCurrentLocationButton: PropTypes.bool,
  openDatePickerOnSelect: PropTypes.bool,
  placeholder: PropTypes.string.isRequired,
  onLocationSelected: PropTypes.func.isRequired,
  externalErrors: PropTypes.object,
  searchType: PropTypes.array,
  /** https://community.algolia.com/places/documentation.html#api-options-type */
  countries: PropTypes.array,
  /** https://community.algolia.com/places/documentation.html#api-options-countries */
  language: PropTypes.string
  /** https://community.algolia.com/places/documentation.html#api-options-language */
};

LocationInput.defaultProps = {
  showCurrentLocationButton: true,
  openDatePickerOnSelect: false,
  isStreet: false,
  isValue: false,
  searchType: ['address', 'city', 'airport'],
  language: 'fr'
};

export default LocationInput;



/** WEBPACK FOOTER **
 ** ./src/components/partials/LocationInput/index.js
 **/